import { GENERIC_IMAGE_APP_KEY } from "@constant/common";
import { updateUserData } from "@context/actions/user";
import {
  AppointmentBookingIcon,
  BackArrowIcon,
  BiCookie,
  BiDownload,
  BiHomeSmile,
  BiLanguage,
  BiListCheck,
  BiLogIn,
  BiLogOut,
  BiPhone,
  BiSearchAlt,
  BiTask,
  BsExclamationSquare,
  BsPerson,
  CgMenuRightAlt,
  CloseLargeIcon,
  FaQuestion,
  FaTasks,
  GoLocation,
  GrContact,
  HiShoppingBag,
  HiSwitchHorizontal,
  HomeIcon,
  IconFrame,
} from '@element/icons';
import { Backdrop } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ConfirmationModal from "@module/confirmationModal";
import SwitchStoreModal from "@module/switchStoreModal";
import UserQueryModal from "@module/userQueryModal";
import UserRegistrationModal from "@module/userRegistration";
import { googleLogout } from "@react-oauth/google";
import { getLanguageKeywords, getLanguages } from "@storeData/common";
import { isSharedLinkPath } from "@util/sharedLinkRoutes";
import { getItemStockByTenantAndStore } from "@storeData/store";
import { updateUserVisitCount } from "@storeData/user";
import { APISERVICE } from "@util/apiService/RestClient";
import { navigateTo } from "@util/routerService";
import { getMobileOperatingSystem } from "@util/utils";
import { getValueFromCookies } from "@util/webstorage";
import { windowRef } from "@util/window";
import { disableLoader, showSuccess, updateActiveLanguage, updateItemStock, updateLanguageKeywords, updateSearchStatus } from "app/redux/actions";
import Link from "next/link";
import { useRouter } from 'next/router';
import React, { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { connect, useDispatch, useSelector } from 'react-redux';

const useStyles = makeStyles({
  list: {
    width: '100%',
  },
  fullList: {
    width: "auto",
  },
});

function MainHeader({ storeData, storeMetaData }) {
  const [cookie, setCookie] = useCookies()
  const [openDrawer, setOpenDrawer] = useState(false);
  const dispatch = useDispatch();
  const baseRouteUrl = useSelector((state: any) => state.store.baseRouteUrl);
  const pdpItem = useSelector((state: any) => state.pdpItem);
  const storesList = useSelector((state: any) => state.storesList);
  const router = useRouter();
  const { configData } = useSelector((state: any) => state.store ? state.store.storeData : null);
  const [showUserRegModalOnFirstLoad, setShowUserRegModalOnFirstLoad] = useState(configData?.storeConfig?.sparkConfig?.userConfig?.userRegPopupReq);
  const [openUserRegistrationModalOnBtnClick, setOpenUserRegistrationModalOnBtnClick] = useState(true);
  const [userData, setUserData] = useState(cookie['user']);
  const [showlogoutPopup, setShowLogoutPopup] = useState(false);
  const cartItems = useSelector((state: any) => state.orderItems);
  const [cartItemQuantity, setCartItemQuantity] = useState(0);
  const genericImages = useSelector((state: any) => state.genericImages);
  const [currentPageName, setCurrentPageName] = useState('');
  const [showPrompt, setShowPrompt] = useState(false);
  const [installAppModal, setInstallAppModal] = useState<any>({ isInstalled: true, promptEvent: null })
  const drawerRef = useRef(null);
  const [currentReleaseVersion, setcurrentReleaseVersion] = useState<any>({})
  const [queryModal, setQueryModal] = useState(false)
  const [switchStoreModal, setSwitchStoreModal] = useState(false)
  const keywords = storeData.keywords;
  const basicConfig = configData?.storeConfig?.basicConfig
  const store = useSelector((state: any) => state);
  const languageData: any = store.languageKeywords
  const currentPage = useSelector((state: any) => state.currentPage);

  const [languagesList, setLanguagesList] = useState([])
  const [selectedLanguage, setSelectedLanguage] = useState({ "languageId": "en", "displayName": "English" })
  const [openDropdown, setOpenDropdown] = useState(false)

  useEffect(() => {
    if (openDrawer) document.body.classList.add("o-h")
    else document.body.classList.remove("o-h")
  }, [openDrawer])

  const handleLanguageClick = (language) => {
    dispatch(updateActiveLanguage(language))
    setOpenDropdown(false)
    setSelectedLanguage(language);

    getLanguageKeywords(configData.tenantId, configData.storeId, language.languageId).then((keywords: any) => {
      let tempLangData: any = {};
      keywords.map((keywordDetails: any) => {
        tempLangData[keywordDetails.keyword] = keywordDetails.translation
      })
      dispatch(disableLoader());
      dispatch(updateLanguageKeywords(tempLangData));
    }).catch((err) => {
      dispatch(disableLoader());
      console.error(err)
    })
  };

  useEffect(() => {
    getLanguages(storeData.tenantId, storeData.storeId).then((res: any) => {
      const languages = Boolean(res) ? res.filter((l) => l.active) : []
      handleLanguageClick({ "languageId": "en", "displayName": "English" })
      if (!Boolean(languages.find((l: any) => l.displayName == "English"))) {
        languages.push({ "languageId": "en", "displayName": "English" })
      }
      if (Boolean(languages?.length)) {
        setLanguagesList(languages);
      }
    })

  }, [storeData])

  const onOutsideClick = (event: any) => {
    if (drawerRef.current && !drawerRef.current.contains(event.target)) {
      toggleDrawer();
    }
  }

  const toggleDrawer = () => {
    if (!openDrawer) {
      setOpenUserRegistrationModalOnBtnClick(false);
      setShowUserRegModalOnFirstLoad(false);
    }
    setOpenDrawer(openDrawer ? false : true);
  };

  const onClickNavItem = (navItem: any) => {
    switch (navItem.route) {
      case 'login':
        setOpenUserRegistrationModalOnBtnClick(true);
        break;
      case 'logout':
        setShowLogoutPopup(true)
        break;
      case 'install-app':
        if (installAppModal.promptEvent) {
          handlePromptClose(true);
        } else setShowPrompt(true);
        break;
      case 'phone':
        window.open(`tel:+${storeMetaData?.countryCode} ${storeMetaData?.phone1}`, '_blanck')
        break;
      default:
        navigateTo(navItem.route);
        // router.push({ pathname: baseRouteUrl + navItem.route }, '', { shallow: true })
        break;
    }
    setOpenDrawer(false);
  }

  const renderNav = () => {
    const NAV_LIST = [
      {
        title: `${languageData["Home"] ? languageData["Home"] : "Home"}`,
        route: 'home',
        icon: <BiHomeSmile />,
        isVisible: true
      },
      {
        title: `${languageData["Order History"] ? languageData["Order History"] : "Order History"}`,
        route: 'myorders',
        icon: <FaTasks />,
        isVisible: userData ? true : false
      },
      {
        title: `${languageData['Booking History'] ? languageData['Booking History'] : 'Booking History'}`,
        route: 'appointmenthistory',
        icon: <AppointmentBookingIcon />,
        isVisible: userData ? true : false
      },
      {
        title: `${languageData["Profile"] ? languageData["Profile"] : "Profile"}`,
        route: 'profile',
        icon: <BsPerson />,
        isVisible: userData ? true : false
      },
      {
        title: `${languageData["Referral"] ? languageData["Referral"] : "Referral"}`,
        route: 'referral',
        icon: <HiShoppingBag />,
        isVisible: userData ? true : false
      },
      {
        title: `${languageData["Privacy Policy"] ? languageData["Privacy Policy"] : "Privacy Policy"}`,
        route: 'privacy',
        icon: <BiTask />,
        isVisible: !(configData?.storeConfig?.sparkConfig?.hidePrivacyPage)
      },
      {
        title: `${languageData["Terms & conditions"] ? languageData["Terms & conditions"] : "Terms & conditions"}`,
        route: 'terms',
        icon: <BiListCheck />,
        isVisible: !(configData?.storeConfig?.sparkConfig?.hideTermsPage)
      }, {
        title: `${languageData["Cookie policy"] ? languageData["Cookie policy"] : "Cookie policy"}`,
        route: 'cookie-policy',
        icon: <BiCookie />,
        isVisible: false
      }, {
        title: `${languageData["Contact Us"] ? languageData["Contact Us"] : "Contact Us"}`,
        route: 'contact-us',
        icon: <GrContact />,
        isVisible: false
      }, {
        title: `${languageData["About Us"] ? languageData["About Us"] : "About Us"}`,
        route: 'about-us',
        icon: <BsExclamationSquare />,
        isVisible: false
      }, {
        title: `${languageData["Store Locator"] ? languageData["Store Locator"] : "Store Locator"}`,
        route: 'storelocator',
        icon: <GoLocation />,
        isVisible: configData.showStoreLocator || false
      }, {
        title: `${languageData["Install App"] ? languageData["Install App"] : "Install App"}`,
        route: 'install-app',
        icon: <BiDownload />,
        isVisible: !installAppModal.isInstalled && storeData?.configData?.storeConfig?.manifestConfig
      }, {
        title: `${languageData["Login"] ? languageData["Login"] : "Login"}`,
        route: 'login',
        icon: <BiLogIn />,
        isVisible: !userData
      }, {
        title: `${languageData["Logout"] ? languageData["Logout"] : "Logout"}`,
        route: 'logout',
        icon: <BiLogOut />,
        isVisible: !!userData
      }
    ];

    const toggleDropdown = () => {
      setOpenDropdown(!openDropdown);
    };

    return (<div>
      {NAV_LIST.map((navItem) => (
        <React.Fragment key={navItem.route}>
          {navItem.isVisible &&
            <div
              key={navItem.route}
              className={`nav-wrap${currentPage === navItem.route || (navItem.route === 'referral' && currentPage === 'referral-add') ? ' active' : ''}`}
              onClick={() => onClickNavItem(navItem)}
            >
              <div className="nav-icon">{navItem.icon}</div>
              <div className="nav-text">{navItem.title}</div>
            </div>}
        </React.Fragment>
      ))}

      <>
        {Boolean(languagesList?.length > 1) && (
          <div className="nav-wrap" onClick={() => toggleDropdown()}>
            <div className="nav-icon">
              <BiLanguage />
            </div>
            <div className="nav-text">{store.activeLanguage.displayName || selectedLanguage.displayName}</div>
            {openDropdown && (
              <div className="dropdown-menu">
                {languagesList.map((language) => (
                  <div
                    key={language.id}
                    className="dropdown-item"
                    onClick={() => handleLanguageClick(language)}
                  >
                    {language.displayName}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </>
      <React.Fragment key={Math.random()}>
        {(storesList.length > 1 && Boolean(configData?.storeConfig?.sparkConfig?.showBranchSelection)) &&
          <div key={Math.random()} className="nav-wrap" onClick={() => setSwitchStoreModal(true)}>
            <div className="nav-icon"> <HiSwitchHorizontal /></div>
            <div className="nav-text cap-text">{languageData["Change"] ? languageData["Change"] : "Change"} {keywords?.branch || "Store"}</div>
          </div>}
      </React.Fragment>
    </div >)

  }

  useEffect(() => {
    if (windowRef) {
      window.addEventListener('beforeinstallprompt', (event: any) => {
        if (!installAppModal.promptEvent) {
          event.preventDefault();
          setInstallAppModal({ ...installAppModal, promptEvent: event, isInstalled: false });
        }
      });
    }
  }, [baseRouteUrl, windowRef]);


  useEffect(() => {
    if (windowRef) {
      // This header mounts for one render on shared invoice/feedback links before the mini header
      // replaces it. Stock levels are only read by the cart and PDP, so skip the call there and
      // leave the customer's rate-limit budget for the record they actually came to see.
      const isSharedLink = typeof window !== 'undefined' && isSharedLinkPath(window.location.pathname);
      if (!isSharedLink && configData?.orderingOn && !configData?.storeOff && !configData?.readOnlyMenu && configData?.storeConfig?.basicConfig?.inventory) {
        getItemStockByTenantAndStore(storeData.tenantId, storeData.storeId).then((itemStockRes) => {
          if (itemStockRes) dispatch(updateItemStock(itemStockRes));
        }).catch((error: any) => {
          console.error(error)
        })
      }
    }

  }, [windowRef])

  const handlePromptClose = async (status: any) => {
    if (status && installAppModal.promptEvent) {
      // Show the install prompt
      installAppModal.promptEvent.prompt();
      // Wait for the user to respond to the prompt
      const { outcome } = await installAppModal.promptEvent.userChoice;
      installAppModal.promptEvent.preventDefault();
      setShowPrompt(false);
      if (outcome == 'accepted') setInstallAppModal({ ...installAppModal, isInstalled: true })
      // Optionally, send analytics event with outcome of user choice
      // We've used the prompt, and can't use it again, throw it away
    }
    setShowPrompt(false);
  }


  useEffect(() => {
    setTimeout(() => {
      if ((!installAppModal.isInstalled || installAppModal.promptEvent) || getMobileOperatingSystem() == 'IOS') {
        if ((window && window.navigator && window.navigator['standalone']) || (window.matchMedia("(display-mode: standalone)").matches)) {
          setInstallAppModal({ ...installAppModal, isInstalled: true });
        } else {
          setInstallAppModal({ ...installAppModal, isInstalled: false });
        }
        // setShowPrompt(true);
      } else {
        // navigator.serviceWorker.getRegistration(window.location.origin).then((registrations) => {
        //   console.log(registrations)
        // });
        setInstallAppModal({ ...installAppModal, isInstalled: false });
      }
    }, 50000);
  }, [])

  useEffect(() => {
    if (cookie['grp']) {
      document.body.dataset.theme = cookie['grp'];
    }
  }, [])

  useEffect(() => {
    if (cookie['user'] && cookie['user'].mobileNo) {
      setUserData(cookie['user'])
    } else setUserData(null)
  }, [cookie, openDrawer])

  useEffect(() => {
    let currentRouteSTring = ('pagepath' in router.query) ? router.query.pagepath[0] : '';
    if (currentRouteSTring.includes('grp')) currentRouteSTring = 'home';
    if (router.asPath.includes('referral/add')) {
      setCurrentPageName('referral');
    } else if (!currentRouteSTring || currentRouteSTring == 'home' || currentRouteSTring == 'orderconfirmation' || currentRouteSTring == 'profile' || currentRouteSTring == 'privacy' || currentRouteSTring == 'terms' || currentRouteSTring == 'myorders' || currentRouteSTring == 'checkout' || currentRouteSTring == 'payment' || currentRouteSTring == 'referral' || currentRouteSTring == 'appointmenthistory') {
      setCurrentPageName(currentRouteSTring)
    } else setCurrentPageName('categories')
    setUserCount();
  }, [router])


  useEffect(() => {
    if (cartItems && cartItems.length && windowRef) {
      let qty = 0;
      cartItems.map((cartItem) => qty += cartItem.quantity)
      if (cartItemQuantity != qty) {
        setCartItemQuantity(qty);
        let element = document.getElementById('cart-item-count')
        if (element) {
          element.classList.add("shake")
          setTimeout(() => {
            element.classList.remove("shake")
          }, 1000);
        }
      }
    }
  }, [cartItems])

  useEffect(() => {
    //set app bg when gender change (so genericImages changes)
    let defaultWrapper = document.getElementById('default-wrapper');
    defaultWrapper && genericImages[GENERIC_IMAGE_APP_KEY] && (defaultWrapper.style.backgroundImage = `url(/assets/${genericImages[GENERIC_IMAGE_APP_KEY]})`)
  }, [genericImages])

  const onLoginClose = (user) => {
    setUserData(user);
    setOpenUserRegistrationModalOnBtnClick(false);
    setShowUserRegModalOnFirstLoad(false);
    setUserCount();
    (user && openUserRegistrationModalOnBtnClick) && dispatch(showSuccess(`${languageData['Login successfully'] ? languageData['Login successfully'] : 'Login successfully'}`))
  }

  const handleLogoutModalResponse = async (status) => {
    if (status) {
      try {
        await APISERVICE.POST(`${process.env.NEXT_PUBLIC_BASE_PCS_URL}/logout`, {});
      } catch (error) {
        console.error("Backend logout failed:", error);
      } finally {
        setCookie("user", {}, { //user registration fields
          path: "/",
          expires: new Date(new Date().setSeconds(1)),
          sameSite: true,
        })
        setCookie('lvt', new Date(), { //registration-screen-time
          path: '/',
          expires: new Date(),
          sameSite: true,
        })
        setUserData(null);
        dispatch(updateUserData(null));
        dispatch(showSuccess(`${languageData['Logout successfully'] ? languageData['Logout successfully'] : 'Logout successfully'}`));
        googleLogout();
        localStorage.clear();
        navigateTo('home');
      }
    }
    setShowLogoutPopup(false);
  }

  const openSearchPage = () => {
    dispatch(updateSearchStatus(true));
  }

  const setUserCount = () => {
    let user: any = getValueFromCookies("user");
    if (user) {
      const lastVisitTime = getValueFromCookies("lvt");
      if (!lastVisitTime) {
        user = JSON.parse(user);
        updateUserVisitCount(user.id).then(() => {
          setCookie("lvt", new Date(), { //registration-screen-time
            path: "/",
            expires: new Date(new Date().setMinutes(new Date().getMinutes() + 5)),
            sameSite: true,
          })
        }).catch(function (error) {
          console.error(error)
        });
      }
    }
  }

  const toggleQueryModal = () => {
    setQueryModal(!queryModal)
  }

  if (currentPageName == "payment") {
    let defaultWrapper = document.getElementById('default-wrapper-content');
    defaultWrapper && (defaultWrapper.style.marginTop = "0");
    return (
      null
    )
  }

  return (
    <>
      <div className="mainheaderblock">
        {currentPageName != 'categories' ? <div className="logo">
          <Link href={baseRouteUrl + 'home'} shallow={true}>
            <img
              src={storeMetaData ? storeMetaData?.logoPath : 'https://pcs-s3.s3.ap-south-1.amazonaws.com/2/logo/2022-09-16T10%3A06%3A23.774113_slider.png'}
              title="logo"
              alt="logo"
            />
          </Link>
        </div> :
          <>
            <div className="logo back-navigation">
              <div className="" onClick={() => router.back()}>
                <IconFrame shape="circle" width={40} height={40} padding="8px"><BackArrowIcon /></IconFrame>
              </div>
              <Link href={baseRouteUrl + 'home'} shallow={true}>
                <div className="">
                  <IconFrame shape="circle" width={40} height={40} padding="8px" margin="0 0 0 8px"><HomeIcon /></IconFrame>
                </div>
              </Link>
            </div>
          </>
        }

        <div className="header-nav-wrap">

          {configData?.storeConfig?.sparkConfig?.showEnquiry && <div className="icon-wrap" onClick={toggleQueryModal}>
            <div className="icon " style={{ padding: 4 }}><FaQuestion /></div>
          </div>}

          <div className="icon-wrap" onClick={openSearchPage}>
            <div className="icon "><BiSearchAlt /></div>
          </div>

          <div className="icon-wrap" >
            <a href={`tel:+${storeMetaData?.countryCode} ${storeMetaData?.phone1}`}>
              <div className="icon "><BiPhone /></div>
            </a>
          </div>

          {(configData?.orderingOn && !configData?.storeOff && !configData?.readOnlyMenu) &&
            <div className="icon-wrap cart-icon" onClick={() => onClickNavItem({ route: 'cart' })}>
              {(cartItems && cartItems.length != 0) && <div className="cart-item-count" id="cart-item-count">{cartItemQuantity}</div>}
              <div className="icon "><HiShoppingBag /></div>
            </div>}

          <div className="icon-wrap" onClick={toggleDrawer}>
            <div className="icon "><CgMenuRightAlt /></div>
          </div>
        </div>

        {openDrawer && <Backdrop
          className=" navigation-drawer-backdrop-modal-wrapper"
          style={{ height: '100vh', width: `${openDrawer ? '100%' : '0'}` }}
          onClick={onOutsideClick}
          open={openDrawer ? true : false}
        >
          <div className="navigation-drawer-backdrop backdrop-modal-content"
            style={{ width: `${openDrawer ? '70%' : '0'}` }}
            ref={drawerRef}
          >
            <section className="drawer-wrap">
              <div className="drawclose" onClick={toggleDrawer}>
                <IconFrame><CloseLargeIcon /></IconFrame>
              </div>
              <div className="drawgraphic">
                <div className="drawer-display-img">
                  <img src={storeMetaData ? storeMetaData?.logoPath : 'https://pcs-s3.s3.ap-south-1.amazonaws.com/2/logo/2022-09-16T10%3A06%3A23.774113_slider.png'} />
                </div>
              </div>
              <div>
                {userData &&
                  <div className="user-details">
                    <div className="name">{userData.firstName}</div>
                    <div className="number">{basicConfig.multipleCountryCode ? '+' + userData.countryCode : ""} {userData.mobileNo}</div>
                  </div>}

                <div className="drawmenu"> {renderNav()}</div>
                {!window.location.href.includes("anjanakesari") && <div className="powered-by" onClick={() => window.open('https://respark.in/', '_blank')}>
                  {Boolean(currentReleaseVersion?.version) && <span>You're on Version <span>{currentReleaseVersion?.version}</span></span>}
                  <span> {languageData["Powered by"] ? languageData["Powered by"] : "Powered by"}<span> Respark</span></span>
                </div>}
              </div>
            </section>
          </div>
        </Backdrop>}
      </div >
      <SwitchStoreModal storeData={storeData} openModal={switchStoreModal} handleClose={() => setSwitchStoreModal(false)} storesList={storesList} />

      <UserRegistrationModal
        fromPage={(!userData?.mobileNo && (openUserRegistrationModalOnBtnClick || showUserRegModalOnFirstLoad) && windowRef && !pdpItem) ? showUserRegModalOnFirstLoad ? "INITIAL_LOAD" : 'HOME' : ''}
        handleResponse={(e) => onLoginClose(e)}
        isApppGrpChangeOnUserGdrChange={showUserRegModalOnFirstLoad ? true : false}
        open={userData?.mobileNo ? false : (openUserRegistrationModalOnBtnClick || showUserRegModalOnFirstLoad) && (windowRef && !pdpItem)}
        heading={configData?.storeConfig?.sparkConfig?.userConfig?.popupHeading ? (configData?.storeConfig?.sparkConfig?.userConfig?.popupHeading) : `${languageData['We will use your information to send offers and promotions'] ? languageData['We will use your information to send offers and promotions'] : 'We will use your information to send offers and promotions'}`} />

      <ConfirmationModal
        openModal={showlogoutPopup}
        title={`${languageData["Logout confirmation"] ? languageData["Logout confirmation"] : "Logout confirmation"}`}
        message={`${languageData["Are you sure you want to logout?"] ? languageData["Are you sure you want to logout?"] : "Are you sure you want to logout?"}`}
        buttonText={`${languageData["No"] ? languageData["No"] : "No"}`}
        secondaryButtonText={`${languageData["Yes"] ? languageData["Yes"] : "Yes"}`}
        handleClose={(status) => handleLogoutModalResponse(status)}
      />

      <UserQueryModal
        openModal={queryModal}
        handleClose={() => toggleQueryModal()}
      />
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    storeData: state?.store?.storeData,
    storeMetaData: state?.store?.storeMetaData
  }
}

export default connect(mapStateToProps)(MainHeader);
